<input
  #input
  (keydown)="onKeyDown($event)"
  [(ngModel)]="editorValue"
  style="width: 100%"
  type="text"
/>
